import React, { Component } from "react";
import MainPicture from "../Section/MainPicture";
import image from './img/centraliser-donnees.png';
import LeftPictureBackground from "../Section/LeftPictureBackground";
import picturemethodo from "./img/apps.png";
import picturequality from "./img/communication-service.png";
import RightPicture from "../Section/RightPicture";
import CheckModule from "../Section/CheckModule";
import pictureevol from "./img/sur-mesure.png";
import technologies from "../../../static/images/technologies.png";
import symfony from "../../pages/img/symfony.png";
import nodejs from "./img/nodejs.png";
import angular from "./img/angular-react.png";
import database from "./img/base-de-donnee.png";
import elasticsearch from "./img/elasticsearch.png";
import html from "./img/html-css-js.png";

class Webapp extends Component {
  render() {
    let title = "Application Web";
    let goto = "En découvrir plus";
    let alt = "test";
    let description = ["Nous vous accompagnons dans la  ", <strong>réalisation de portails Web</strong>, " adaptés à votre organisation. Un de nos objectifs est de vous permettre de centraliser et retrouver vos données en toute ", <strong>simplicité et sécurité</strong>, "."];

    let smalltitle = "Optimiser l'exploitation de vos données";
    let titlemethodo = "Aggrégation d'outils au service de votre efficacité";
    let descriptionmethodo = [
        "La mise en place d'un intranet ou portail au sein de votre organisation a l'avantage de centraliser vos données, mais aussi vos outils en ", 
        <strong>un seul et unique système</strong>, ".", <br />, "Vous pouvez par exemple retrouver:", <ul><li>La saisie des demandes de congés,</li><li>la gestion des notes de frais,</li><li>la base de données client,</li><li>CRM,</li><li>...</li></ul>,
        "Les processus internes sont disponibles et encadrés autour d'une seule application accessible partout et tout le temps !"
    ];
    let pictureMethodo = picturemethodo;
    let altmethodo = "Méthodologie agile Scrum en image";



    let smalltitleevol = "Faite évoluer votre portail avec votre organisation";
    let titleevol = "Le portail sur-mesure";
    let descriptionevol = ["Nous vous apportons notre expertise composée du ", <strong>conseil</strong>, " et de l'accompagnement nécessaire à la réalisation d'un portail collaboratif efficace.", 
                            <br />,"Toute structure est unique, c'est pourquoi nous privilégions la conception de portail intranet/extranet sur-mesure.",
                            <br />, <br />, "Notre expérience dans le ", <strong>système d'information</strong>, " vous garantit une intégration ", <strong>sécurisée</strong>, " et optimale dans votre environnement informatique afin d'éviter la dupplication de données et les ressaisies rébarbatives."];

    let altevol = "Intégration du portail dans votre système d'informations";



    let smalltitleCheck = "Intégrer vos clients et fournisseurs dans votre communication 360°" ;
    let titleCheck = "Carrefour de la communication entre tous les acteurs de votre organisation";
    let subtitle1Check = "Vos clients";
    let text1Check = ["Gardez vos clients au centre de votre préoccupation en les invitants à utiliser votre portail. Améliorez la traçabilité de vos communications !", <br />, "Proposez des services en ligne inédits !" ];
    let subtitle2Check = "Vos fournisseurs et partenaires";
    let text2Check = "Communiquez efficacement avec vos partenaires tout en gardant une traçabilité de vos échanges.";
    let subtitle3Check = "Vos collaborateurs";
    let text3Check = "Toute votre structure peut communiquer en interne et avec des tiers. Le suivi et le partage de l'information  optimisent la transmission de la connaissance !";
    let pictureCheck = picturequality;
    let altCheck = "La communication 360°";

    return (
      <div className="generic-services">
        <MainPicture title="Centraliser vos données pour améliorer votre productivité" description={description} picture={image} alt={alt} />
        <RightPicture smalltitle={smalltitleevol} title={titleevol} description={descriptionevol} picture={pictureevol} alt={altevol} />
        <LeftPictureBackground smalltitle={smalltitle} title={titlemethodo} description={descriptionmethodo} picture={pictureMethodo} alt={altmethodo} />
        <CheckModule 
                smalltitle={smalltitleCheck} 
                title={titleCheck}
                subtitle1={subtitle1Check}
                text1={text1Check}
                subtitle2={subtitle2Check}
                text2={text2Check}
                subtitle3={subtitle3Check}
                text3={text3Check}
                picture={pictureCheck}
                alt={altCheck}
        />
        <RightPicture smalltitle={smalltitleevol} title={titleevol} description={descriptionevol} picture={pictureevol} alt={altevol} />
      </div>
    );
  }
}

export default Webapp;



// WEBPACK FOOTER //
// ./src/components/Page/Portail.jsx